import Favicon from "../../../images/favicon/favicon-128.png"
import {Link} from "react-router-dom";
import React from "react";
import Language from "../../../enums/LanguageEnum";
const CountryFlag = ({ flag }) => (
    <img
        alt={flag.alt}
        src={flag.src}
        width={24}
        className="me-1"
    />
);

// $( document ).ready(function() {
//     const language = sessionStorage.getItem("ABLanguage") || "English";
//     // $alphabet = Alphabet();
//     // $alphabet.set(language);
//
//     setLanguageFlag(language);
//     // generateKeyboard(language);
// });
export default function Navbar({flag, updateLanguage, getLanguage}) {
    function onUpdateLanguage(e, language){
        updateLanguage(e, language);
        console.log("onUpdateLanguage", e.target, language);

        window.location.reload();
        hideNavbar();
    }

    return (
        <>
            <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand" href="#"><img src={Favicon} height="32"></img></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup"
                            aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <ul className="navbar-nav align-items-end">
                            <li className="nav-item dropdown d-flex flex-column align-items-end">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                                   aria-expanded="false">
                                    <CountryFlag flag={flag}/>
                                </a>
                                <div className="dropdown-menu">
                                    <a className="dropdown-item" role="button"
                                       onClick={(e) => {
                                           onUpdateLanguage(e, Language.English.name);
                                       }}>
                                        <span className="d-flex align-items-center">
                                            <CountryFlag flag={getLanguage(Language.English.name).flag}></CountryFlag>
                                            {Language.English.name}
                                        </span>
                                    </a>
                                    <a className="dropdown-item" role="button"
                                       onClick={(e) => {
                                           onUpdateLanguage(e, Language.Czech.name);
                                       }}>
                                        <span className="d-flex align-items-center">
                                            <CountryFlag flag={getLanguage(Language.Czech.name).flag}></CountryFlag>
                                            {Language.Czech.name}
                                        </span>
                                    </a>
                                </div>
                            </li>
                            <li className="nav-item">
                                <Link to="/alpha-baby" onClick={hideNavbar} className="nav-item nav-link active redirect-link" aria-current="page">
                                    Alpha Baby<span className="sr-only"></span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/pairs" onClick={hideNavbar} className="nav-item nav-link active redirect-link" aria-current="page">
                                    Pairs<span className="sr-only"></span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/privacy" onClick={hideNavbar} className="nav-item nav-link redirect-link">
                                    Privacy Policy<span className="sr-only"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}
export const hideNavbar = () => document.getElementById("navbarNavAltMarkup").classList.remove("show");